import { render, staticRenderFns } from "./CandidateFeedbackIcon.vue?vue&type=template&id=3ec4fc90"
import script from "./CandidateFeedbackIcon.vue?vue&type=script&lang=js"
export * from "./CandidateFeedbackIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports